@if (loading && !diaries.length) {
  <div class="no-data">Loading…</div>
} @else if (diaries.length) {
  <div class="wrapper flex flex-col gap-[40px]">
    @for (diary of diaries; track diary.id || diary.uuid) {
      <div class="each-diary">
        <div
          (click)="selectDiary(diary)"
          [class]="'header flex justify-between ' + diary.status"
        >
          <div class="left">
            <div class="name text-type-5">
              @if (diary?.createdBy) {
                {{ diary.createdBy.first_name }} {{ diary.createdBy.last_name }}
              } @else {
                &mdash;
              }
            </div>
            <div class="filed-on text-type-10">
              {{ diary?.created_at | date : 'hh:mm a on MMMM dd, yyyy' }}
            </div>
            <div class="status text-type-10">
              {{ diary?.status === 'submitted' ? 'Submitted' : 'Draft' }}
            </div>
          </div>
          <div class="right flex flex-row gap-[10px]">
            <mat-icon
              [svgIcon]="selectedDiaryId === (diary.id || diary.uuid) && !userCollapsed ? 'chevron-up' : 'chevron-down'"
              class="chevron"
            />
            @if (hasMenu(diary)) {
              <mat-icon (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu" class="chevron !mt-[5px]">
                more_horiz
              </mat-icon>
              <mat-menu #menu="matMenu">
                <button (click)="delete($event, diary)" mat-menu-item data-testid="diary-delete-btn">
                  <mat-icon svgIcon="trash" />
                  Delete diary
                </button>
              </mat-menu>
            }
          </div>
        </div>
        @if (selectedDiaryId === (diary.id || diary.uuid) && !userCollapsed) {
          <div class="content">
            <hr class="divider" />
            <app-daily-diary-detail
              [diary]="diary"
              [projectId]="projectId"
              [siteId]="siteId"
            />
            <!-- Submit sits under the record, like a daily report's workflow
                 action. A submitted diary can be pushed again. -->
            @if (canSubmit(diary)) {
              <div class="diary-actions flex flex-row-reverse pt-[24px]">
                <app-primary-button
                  (handleClick)="submit($event, diary)"
                  [isDisabled]="submitting"
                  class="!w-[180px]"
                  data-testid="diary-submit-btn"
                >
                  {{ submitting ? 'Submitting…' : submitLabel(diary) }}
                </app-primary-button>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="no-data">No diaries available for the selected date.</div>
}
